"use strict";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var React = require('react');

var startCase = require('lodash/startCase');

var PropTypes = require('prop-types');

var moment = require('moment');

var TableNumbersByPaperType = require('../components/TableNumbersByPaperType');

var TableNumbersShipment = require('../components/TableNumbersShipment');

function TableNumbers(props) {
  var PrintJobs = props.PrintJobs,
      Shipments = props.Shipments,
      user = props.user;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "Sent By ", startCase(user.displayName), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("span", null, "Print by Date: ", moment(PrintJobs[0].print_by_date).format('ddd MMM DD YYYY'), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), ['White Shimmer', 'Ivory Shimmer', 'White Matte', 'White Cotton', 'Double Thick White Cotton', 'Ivory Matte', 'Ivory Cotton', 'Double Thick Ivory Cotton', 'Double Thick White Matte', 'Double Thick Ivory Matte'].map(function (paperType) {
    return /*#__PURE__*/React.createElement(TableNumbersByPaperType, _extends({
      key: paperType,
      paperType: paperType
    }, props));
  }), /*#__PURE__*/React.createElement("br", null), "----------", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), Shipments.map(function (shipment) {
    return /*#__PURE__*/React.createElement("div", {
      key: shipment.id
    }, /*#__PURE__*/React.createElement(TableNumbersShipment, {
      shipment: shipment
    }), /*#__PURE__*/React.createElement("br", null));
  }));
}

TableNumbers.propTypes = {
  PrintJobs: PropTypes.array.isRequired,
  Shipments: PropTypes.array.isRequired,
  user: PropTypes.shape({
    displayName: PropTypes.string.isRequired
  }).isRequired,
  options: PropTypes.object
};
module.exports = TableNumbers;